function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.8483 5.03173C13.1162 4.77575 13.5462 4.77575 13.814 5.03173L21.5742 12.471V22.6632C21.5742 23.3991 20.9587 23.9964 20.2004 23.9964H17.453C16.6947 23.9964 16.0793 23.3991 16.0793 22.6632V14.6641H10.5844V22.6632C10.5844 23.3991 9.96899 23.9964 9.21069 23.9964H6.46326C5.70359 23.9964 5.08954 23.3991 5.08954 22.6632V12.4696L12.8483 5.03173ZM20.8873 -0.000415782V6.36292L25.6953 11.0291C26.0978 11.4197 26.0978 12.053 25.6953 12.4436C25.2928 12.8342 24.6403 12.8342 24.2378 12.4436L14.0599 2.56465C13.6602 2.17669 13.0035 2.17669 12.6038 2.56465L2.42589 12.4436C2.0234 12.8342 1.37088 12.8342 0.968379 12.4436C0.565879 12.053 0.565879 11.4197 0.968379 11.0291L11.6326 0.679513C12.5667 -0.227059 14.097 -0.227059 15.0311 0.679513L18.8267 4.36313V-0.000415782H20.8873Z",
  fill: "#28C9C6"
});

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.31300442.svg";
export { ForwardRef as ReactComponent };